// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import Plausible from 'plausible-tracker';
import type { AnalyticsProviderAdapter, PlausibleConfig } from '../types';

export function createPlausibleAdapter(
  config: PlausibleConfig,
  debug?: boolean
): AnalyticsProviderAdapter {
  let plausibleInstance: ReturnType<typeof Plausible> | null = null;

  return {
    name: 'plausible',
    requiresConsent: false,

    init() {
      plausibleInstance = Plausible({
        domain: config.domain,
        apiHost: config.apiHost || 'https://plausible.io',
        trackLocalhost: debug === true,
      });
    },

    page(path: string, props?: Record<string, string>) {
      plausibleInstance?.trackPageview({ url: path }, { props });
    },

    track(event: string, props?: Record<string, string>) {
      plausibleInstance?.trackEvent(event, { props });
    },

    identify() {
      // Plausible doesn't support user identification — no-op
    },

    destroy() {
      plausibleInstance = null;
    },
  };
}
